export default "__VITE_ASSET__DCFKFpT___"